import { globalData } from "../globals";

const YANDEX_METRIKA_COUNTER_ID = 110820059;

const isLocalhost = () => {
  if (typeof window === "undefined") {
    return true;
  }

  return ["localhost", "127.0.0.1", "0.0.0.0", "::1"].includes(window.location.hostname);
};

const isAdmin = () => {
  return globalData.CurrentUser?.role === "admin";
};

const canTrack = () => {
  return !isLocalhost() && !isAdmin() && typeof window.ym === "function";
};

export const YandexMetrika = {
  reachGoal(goal: string, params?: Record<string, unknown>) {
    if (!canTrack()) return;

    window.ym?.(YANDEX_METRIKA_COUNTER_ID, "reachGoal", goal, params);
  },

  hit(url: string) {
    if (!canTrack()) return;

    window.ym?.(YANDEX_METRIKA_COUNTER_ID, "hit", url);
  },
};
